interface Props {
  onClick?: () => void;
}

export const EditMemoButton: React.FC<Props> = ({ onClick }: Props) => {
  return (
    <button
      onClick={onClick}
      className="rounded-md bg-grayscale-contrast-2 w-14 h-7 text-footnote-description text-semantic-text-body"
    >
      메모 수정
    </button>
  );
};
